import { render, staticRenderFns } from "./StudentBase.vue?vue&type=template&id=4f3f35e4&scoped=true&"
import script from "./StudentBase.vue?vue&type=script&lang=js&"
export * from "./StudentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f35e4",
  null
  
)

export default component.exports